import { useState } from 'react';
import { useStateValue } from 'state/index';
import { feedbackSettings, saveFeedbackSettings } from '../queries';
import { setFeedbackOptedOut } from '../actions';
import { onException } from "state/httpStatusHandler";

export const useFeedbackSettings = () => {
  const [state, dispatch] = useStateValue();
  const [isLoading, setIsLoading] = useState(false);

  const loadFeedbackSettings = async () => {
    setIsLoading(true);

    await feedbackSettings()
      .then(response => {
        dispatch(setFeedbackOptedOut(response.data.opted_out));
      })
      .catch(errorObject => onException(errorObject, dispatch, state));
    setIsLoading(false);
  };

  const updateFeedbackOptedOut = async optedOut => {
    setIsLoading(true);

    await saveFeedbackSettings(optedOut)
      .then(response => {
        dispatch(setFeedbackOptedOut(response.data.opted_out));
      })
      .catch(errorObject => onException(errorObject, dispatch, state));
    setIsLoading(false);
  };

  return [state.feedbackOptedOut, isLoading, loadFeedbackSettings, updateFeedbackOptedOut];
};

export default useFeedbackSettings;